'use strict';

define('vb/action/builtin/fireAiResponseEventAction',['vb/action/action', 'vb/private/log', 'vb/private/stateManagement/application',
  'vb/private/utils'],
(Action, Log, Application, Utils) => {
  /** @typedef {import('vb/action/action').Outcome} Outcome */

  const logger = Log.getLogger('/vb/action/builtin/fireAiResponseEventAction');

  /**
   * Represents an action that fires an AI response event with the provided parameters.
   * @extends Action
   * @category Action
   */
  class FireAiResponseEventAction extends Action {
    /**
     * Performs the action of firing an AI response event with the provided parameters.
     *
     * @async
     * @param {Object} parameters - An object containing event details.
     * @param {Object} parameters.payload - Payload associated with the event.
     * @param {string} parameters.event - Name of the event to fire, utilized by the Actions API.
     * @param {string} [parameters.target] - Optional target of the event action. If target is not provided,
     * the event will be broadcast to all plugins that have listeners defined for the event.
     * @returns {Promise<Outcome>} A promise resolving to an outcome object indicating success or failure.
     */
    async perform(parameters) {
      const {
        payload,
        event,
        target,
      } = parameters;

      // to prevent event handlers from making unpredictable changes, pass by value instead of by reference. Event
      // payloads are meant to be serializable any way and must not hold references to state that may not survive
      // the event processing lifecycle
      let clonePayload = payload;
      if (payload) {
        clonePayload = Utils.cloneObject(payload);
      }

      logger.info('FireAiResponseEventAction', this.logLabel, 'with event name', event, 'target name', target,
        'and payload', clonePayload);

      try {
        const result = await Application.aiEventBus
          .fireAiResponseEvent(payload, event, target);
        return Action.createSuccessOutcome(result);
      } catch (error) {
        return Action.createFailureOutcome(error.message, error);
      }
    }
  }

  return FireAiResponseEventAction;
});

